/**
 * 路由处理中心
 * @creater liux
 * @Email   liuxing@autobio.com.cn
 * @Date    2019年8月8日 10:00:00
 */
import Vue from 'vue';
import Router from 'vue-router';
import nprogress from 'nprogress';
import 'nprogress/nprogress.css';
Vue.use(Router);

const _import = (file) => () => import('@/pages' + file + '.vue');

// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
  { path: '/login', component: _import('/OtherLogin'), name: 'login', meta: { title: '登录' } },
  { path: '/callback', component: _import('/CallBack'), name: 'callBack', meta: { title: '云之家授权登陆' } }
];

// 主入口路由(需嵌套上左右整体布局)
const initMainRoutes = {
  path: '/',
  component: _import(`/main/${Vue.prototype.$config.setting.menuLayout}/Main`),
  name: 'main',
  meta: { title: '' },
  children: [
    {
      path: '/personal/year-plan/detail',
      name: 'OEC.PersonalConsole.TbYearPlan.Detail',
      component: _import('/personal/year-plan/Detail'),
      meta: {
        title: '年计划详情',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/personal/year-plan/detail-next',
      name: 'OEC.PersonalConsole.TbYearPlan.DetailNext',
      component: _import('/personal/year-plan/DetailNext'),
      meta: {
        title: '年计划详情',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/personal/week/detail',
      name: 'OEC.PersonalConsole.WeekWork.Detail',
      component: _import('/personal/week/detail'),
      meta: {
        title: '周计划详情',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/personal/month/detail',
      name: 'OEC.PersonalConsole.MonthWork.Detail',
      component: _import('/personal/month/detail'),
      meta: {
        title: '月计划详情',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/personal/day/detail',
      name: 'OEC.PersonalConsole.DayWork.Detail',
      component: _import('/personal/day/detail'),
      meta: {
        title: '日计划详情',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/manage/execute-form/detail',
      name: 'OEC.ManageConsole.ExecuteForm.Detail',
      component: _import('/manage/execute-form/detail'),
      meta: {
        title: '工作项',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
        keepAlive: true
      },
    },
    // {
    //   path: '/personal/revert/index',
    //   name: 'OEC.PersonalConsole.Revert.Index',
    //   component: _import('/personal/revert/index'),
    //   meta: {
    //     title: '撤回管理',
    //     isDynamic: true,
    //     isTab: true,
    //     iframeUrl: '',
    //   },
    // },
    // {
    //   path: '/personal/test/detail',
    //   name: 'OEC.ManageConsole.Test.Detail',
    //   component: _import('/personal/test/detail'),
    //   meta: {
    //     title: '测试',
    //     isDynamic: true,
    //     isTab: true,
    //     iframeUrl: '',
    //   },
    // },
    //  {
    //    path: '/manage/auth/index',
    //    name: 'OEC.ManageConsole.Auth.Index',
    //    component: _import('/manage/auth/index'),
    //    meta: {
    //      title: '测试',
    //      isDynamic: true,
    //      isTab: true,
    //      iframeUrl: '',
    //    },
    //  },
    //  {
    //    path: '/manage/edit-plan/index',
    //    name: 'OEC.ManageConsole.EditGrants.Index',
    //    component: _import('/manage/edit-plan/index'),
    //    meta: {
    //      title: '测试',
    //      isDynamic: true,
    //      isTab: true,
    //      iframeUrl: '',
    //    },
    //  },
    {
      path: '/manage/edit-plan/day',
      name: 'OEC.ManageConsole.EditPlan.Day',
      component: _import('/manage/edit-plan/day'),
      meta: {
        title: '日清',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/manage/edit-plan/week',
      name: 'OEC.ManageConsole.EditPlan.Week',
      component: _import('/manage/edit-plan/week'),
      meta: {
        title: '周计划',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/manage/edit-plan/month',
      name: 'OEC.ManageConsole.EditPlan.Month',
      component: _import('/manage/edit-plan/month'),
      meta: {
        title: '月计划',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/manage/edit-plan/year',
      name: 'OEC.ManageConsole.EditPlan.Year',
      component: _import('/manage/edit-plan/year'),
      meta: {
        title: '年计划',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/manage/edit-plan/year-next',
      name: 'OEC.ManageConsole.EditPlan.YearNext',
      component: _import('/manage/edit-plan/YearNext'),
      meta: {
        title: '年计划',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    // {
    //    path: '/manage/time-grants/index',
    //    name: 'OEC.ManageConsole.TimeGrants.Index',
    //    component: _import('/manage/time-grants/index'),
    //    meta: {
    //      title: '测试',
    //      isDynamic: true,
    //      isTab: true,
    //      iframeUrl: '',
    //    },
    //  },
    // {
    //   path: '/manual/index',
    //   name: 'OEC.manual.index',
    //   component: _import('/manual/index'),
    //   meta: {
    //     title: '使用说明',
    //     isDynamic: true,
    //     isTab: true,
    //     iframeUrl: '',
    //   },
    // },
    {
      path: '/personal/workscore/detail',
      name: 'OEC.PersonalConsole.Workscore.Detail',
      component: _import('/personal/workscore/detail'),
      meta: {
        title: '员工绩效考核表',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/personal/workscore/yearDetail',
      name: 'OEC.PersonalConsole.Workscore.YearDetail',
      component: _import('/personal/workscore/yearDetail'),
      meta: {
        title: '年计划考核表',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/personal/workscore/yearDetailNext',
      name: 'OEC.PersonalConsole.Workscore.YearDetailNext',
      component: _import('/personal/workscore/yearDetailNext'),
      meta: {
        title: '年计划考核表',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/period/manage/workscoreList',
      name: 'OEC.Period.Manage.WorkScoreList',
      component: _import('/period/manage/workscoreList'),
      meta: {
        title: '综合绩效考核表',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/period/manage/workscore',
      name: 'OEC.Period.Manage.WorkScore',
      component: _import('/period/manage/workscore'),
      meta: {
        title: '员工绩效考核表',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/period/manage/yearWorkscore',
      name: 'OEC.Period.Manage.YearWorkScore',
      component: _import('/period/manage/yearWorkscore'),
      meta: {
        title: '年计划考核',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/period/manage/yearWorkScoreNext',
      name: 'OEC.Period.Manage.YearWorkScoreNext',
      component: _import('/period/manage/yearWorkScoreNext'),
      meta: {
        title: '年计划考核',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/period/importance-search/detail',
      name: 'OEC.Period.ImportantSortSearch.Detail',
      component: _import('/period/importance-search/detail'),
      meta: {
        title: '重要度排序',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/response/personal/detail',
      name: 'OEC.Response.Personal.Detail',
      component: _import('/response/personal/detail'),
      meta: {
        title: '岗位职责详情',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
    {
      path: '/response/history/detail',
      name: 'OEC.Response.History.Detail',
      component: _import('/response/history/detail'),
      meta: {
        title: '岗位职责列表',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
        keepAlive: true
      },
    },
    {
      path: '/response/manage/detail',
      name: 'OEC.Response.Manage.Detail',
      component: _import('/response/manage/detail'),
      meta: {
        title: '岗位职责详情',
        isDynamic: true,
        isTab: true,
        iframeUrl: '',
      },
    },
  ],
};

const createRouter = () =>
  new Router({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
    routes: [].concat(globalRoutes, initMainRoutes),
  });

const router = createRouter();
let configOIDC = {
  authority: process.env.VUE_APP_TOKEN_API,
  client_id: '',
  redirect_uri: process.env.VUE_APP_REDIRECT_URI + "/#/callback",
  response_type: "code",
  scope: "openid profile OECService offline_access",
  post_logout_redirect_uri: process.env.VUE_APP_REDIRECT_URI + "/#/login",
  client_secret: 'C60674E11F224B15B6A1725203E7C9A2',
  metadata: JSON.parse(process.env.VUE_APP_META_DATA)
};
router.beforeEach(async (to, from, next) => {
  nprogress.start();
  if (router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, globalRoutes) === 'global') {
    next();
  } else {
    if (Vue.prototype.$userInfo.getLoginInfo().token) {
      //加载用户菜单，动态添加路由
      await Vue.prototype.$ajax.get(Vue.prototype.$api.common.getMenuListData, { name: "OEC" }).then(async res => {
        if (res) {
          const menusObj = { items: res.items || [] };
          const menusArr = menusObj.items;
          // 处理判断OEC建议申报菜单的权限
          await dealRecommendDeclareMenu(menusArr[0].items);
          let menus = packageMenu(menusArr);
          let menusList = menusArr[0].items;
          //  if(menus.some(item=>item.name=='OEC.Period.WorkScore'||item.name=='OEC.Period.PeriodResult'||item.name=='OEC.Period.PeriodHistory'||item.name=='OEC.Period.ImportantSort'||item.name=='OEC.Period.ImportantSortSearch')){
          //   await hasSubUserList().then((data)=>{
          //     if(!data){
          //      menus=menus.filter(item=>item.name!='OEC.Period.WorkScore'&&item.name!='OEC.Period.PeriodResult'&&item.name!='OEC.Period.PeriodHistory'&&item.name!='OEC.Period.ImportantSort'&&item.name!='OEC.Period.ImportantSortSearch')
          //      menusList.forEach(item=>{
          //        if(item.name==='OEC.Period'){
          //          item.items=item.items.filter(v=>v.name!='OEC.Period.WorkScore'&&v.name!='OEC.Period.PeriodResult'&&v.name!='OEC.Period.PeriodHistory'&&v.name!='OEC.Period.ImportantSort'&&v.name!='OEC.Period.ImportantSortSearch')
          //        }
          //      })
          //     }
          //   }).finally(()=>{
          //      if(menusList.find(t=>t.name==='OEC.Period')&&menusList.find(t=>t.name==='OEC.Period').items.length===0){
          //        menusList=menusList.filter(t=>t.name!='OEC.Period');
          //      } 
          //      Vue.prototype.$userInfo.saveMenus(menusList);
          //   })
          //  }else{
          //   Vue.prototype.$userInfo.saveMenus(menusList);
          //  }

          //  hasSortList().then((res)=>{
          //     if(!res){
          //       menus=menus.filter(item=>item.name!='OEC.Period.ImportantSort'&&item.name!='OEC.Period.ImportantSortSearch')
          //       menusList.forEach(item=>{
          //         if(item.name==='OEC.Period'){
          //           item.items=item.items.filter(v=>v.name!='OEC.Period.ImportantSort'&&v.name!='OEC.Period.ImportantSortSearch')
          //         }
          //       })
          //     }
          //  }).finally(()=>{
          //     if(menusList.find(t=>t.name==='OEC.Period')&&menusList.find(t=>t.name==='OEC.Period').items.length===0){
          //       menusList=menusList.filter(t=>t.name!='OEC.Period');
          //     } 
          //     Vue.prototype.$userInfo.saveMenus(menusList);
          //  })
          Vue.prototype.$userInfo.saveMenus(menusList);
          const accessRouter = fnAddDynamicMenuRoutes(menus);
          let mainRoutes = Object.assign({}, initMainRoutes);
          mainRoutes.name = 'main-dynamic';
          mainRoutes.children = [...accessRouter, ...mainRoutes.children];
          router.addRoutes([mainRoutes]);
          sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'));
          router.options.isAddDynamicMenuRoutes = true;
          if (mainRoutes.children.find(r => r.path == to.path)) {
            next({ ...to, replace: true });
          } else {
            next({ name: 'login' })
          }
        }
      }).catch(() => {
        // Vue.prototype.$userInfo.goLoginPage();
      });
    } else {
      if (to.query.origin === 'oa') {
        localStorage.setItem('client', 'OecClientOA');
        // configOIDC.client_id = 'OecClientOA'
      } else {
        localStorage.setItem('client', 'OecClient');
        // configOIDC.client_id = 'OecClient'
      }
      Vue.prototype.$userInfo.goLoginPage();
    }
  }
  configOIDC.client_id = localStorage.getItem('client');
  Vue.prototype.$mgr = new Oidc.UserManager(configOIDC);
});

router.afterEach(() => {
  nprogress.done();
});
//处理返回的菜单数据
function packageMenu(menus, route = []) {
  menus.forEach((v) => {
    if (v.url) {
      route.push({
        path: v.url,
        name: v.name,
        component: v.url,
        isTab: true,
        meta: {
          title: v.displayName,
          icon: v.icon,
        }
      });
    }
    if (v.items.length) {
      packageMenu(v.items, route);
    }
  });
  return route;
}
//移除不显示的菜单
function filterMenu(menus) {
  return menus.filter(v => {
    return v.menuShow === true;
  }).map(item => {
    item = Object.assign({}, item);
    if (item.items) {
      item.items = filterMenu(item.items);
    }
    return item;
  });
}
/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType(route, globalRoutes = []) {
  var temp = [];
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return 'global';
    } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
      temp = temp.concat(globalRoutes[i].children);
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main';
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = []) {
  const accessedRouters = menuList.filter((route) => {
    if (route.component) {
      if (
        route.name == "OEC.MonitorCenter.Approve" ||
        route.name == "OEC.ManageConsole.ExecuteForm" ||
        route.name == "OEC.ManageConsole.WorkManage" ||
        route.name == "OEC.Period.ImportantSortSearch" ||
        route.name == "OEC.Period.PeriodHistory" ||
        route.name == "OEC.Period.Manage" ||
        route.name == "OEC.Period.PeriodManage" ||
        route.name == "OEC.ManageConsole.ReportExport" ||
        route.name == "OEC.Period.ImportanceSortManage" ||
        route.name == "OEC.Response.ResponseManage" ||
        route.name == "OEC.Response.ResponseQuery"
      ) {
        route.meta.keepAlive = true;
      }
      if (route.path.indexOf('Identity') != -1) {
        route.component = _import(route.component + '/Index');
      } else {
        route.component = _import(route.component);
      }
    }
    return true;
  });
  return accessedRouters;
}

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

async function hasSubUserList() {
  return await Vue.prototype.$ajax['post'](Vue.prototype.$api.sys.userInfo.downList,
    { filter: "", SkipCount: 0, MaxResultCount: 20, userSourceType: [3] }, { noLoading: true }
  ).then(res => {
    return res.totalCount > 0;
  })
}
async function hasSortList() {
  const userInfo = sessionStorage.getItem('userInfo');
  const currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';
  return await Vue.prototype.$ajax.get(Vue.prototype.$api.period.importanceSort.search,
    { LoginWkNo: currWkNo, PageIndex: 1, PageSize: 10 }
  ).then((res) => {
    return res.data.total > 0;
  });
}

// OEC建议申报菜单
// 如果menuList中有OEC建议申报，则不作操作；如果没有，则调接口，接口返回true，则添加OEC建议申报，否则不作操作
async function dealRecommendDeclareMenu(menuList) {
  if (!menuList || menuList.length === 0) return [];
  let isExistMenu = false; // 是否存在菜单
  let menuIndex = 0; // 菜单位置
  for (let i = 0; i < menuList.length; i++) {
    if (isExistMenu) break;
    const menu = menuList[i];
    if (menu.elementId === 'MenuItem_OEC.ManageConsole' && menu.items && menu.items.length > 0) {
      for (let j = 0; j < menu.items.length; j++) {
        const item = menu.items[j];
        if (item.elementId === 'MenuItem_OEC.ManageConsole.OecDeclare') {
          menuIndex = j + 1;
        }
        if (item.elementId === 'MenuItem_OEC.ManageConsole.OecRecommend') {
          isExistMenu = true;
          break;
        }
      }
    }
  }
  // 没有OEC建议申报菜单，则调接口
  if (!isExistMenu) {
    const recommendDeclareMenu = {
      "name": "OEC.ManageConsole.OecRecommend",
      "displayName": "OEC建议申报",
      "order": 1000,
      "url": "/manage/recommend-declare/index",
      "icon": "icon-recommend-declare",
      "isLeaf": false,
      "target": null,
      "isDisabled": false,
      "items": [],
      "customData": null,
      "elementId": "MenuItem_OEC.ManageConsole.OecRecommend",
      "cssClass": null
    };
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    if (!userInfo) return menuList;
    const res = await Vue.prototype.$ajax.post(Vue.prototype.$api.common.recommendDeclareMenuTag, {
      id: userInfo.id,
      wkNo: userInfo.wkNo
    }).catch(err => {
      console.error(err);
    });
    // 接口返回true，添加菜单
    if (res.data) {
      let manageMenu = null;
      for (let i = 0; i < menuList.length; i++) {
        const menu = menuList[i];
        if (menu.elementId === 'MenuItem_OEC.ManageConsole') {
          manageMenu = menu;
          break;
        }
      }
      // 判断父级菜单是否存在，不存在则添加，存在则直接添加到子菜单
      if (!manageMenu) {
        manageMenu = {
          "name": "OEC.ManageConsole",
          "displayName": "管理工作台",
          "order": 1000,
          "url": null,
          "icon": "icon-manage-5",
          "isLeaf": false,
          "target": null,
          "isDisabled": false,
          "items": [recommendDeclareMenu],
          "customData": null,
          "elementId": "MenuItem_OEC.ManageConsole",
          "cssClass": null
        }
      } else {
        if (!manageMenu.items) manageMenu.items = [];
        manageMenu.items.splice(menuIndex, 0, recommendDeclareMenu);
      }
    }
    return menuList;
  }
}

export default router;
